
import ActsAsBanner from '@mixins/ActsAsBanner';
import { resolvePathFromSegments } from '@/support';

export default {
  mixins: [ActsAsBanner],

  computed: {
    id() {
      return `banner-${Number(new Date())}`;
    },
  },
};
